import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useState } from "react";

import { hasForbiddenChar } from "@/components/membership/Template/utils/templateUtils";
import { FORBIDDEN_CHARS } from "@/constants/forbiddenCharacters";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

const TemplateNameModal = ({
  title,
  message = "",
  handleSubmit,
  isNew = false,
}) => {
  const { templateData } = useUpdateDataContext();
  const [open, setOpen] = useState(false);
  const [inputIsInvalid, setInputIsInvalid] = useState(false);
  const [templateName, setTemplateName] = useState(
    isNew ? "" : templateData.name
  );
  const [isCatalistOnly, setIsCatalistOnly] = useState(
    isNew ? false : templateData.use === "catalist-only"
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    setTemplateName(input);
    setInputIsInvalid(hasForbiddenChar(input));
  };

  const handleCatalistChange = (e) => {
    setIsCatalistOnly(e.target.checked);
  };

  const handleContinue = () => {
    handleSubmit(templateName, isCatalistOnly);
    handleClose();
  };

  return (
    <>
      <Button className="siteBlueOutlined" onClick={handleClickOpen}>
        {title}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        data-testid="template-name-modal"
        sx={{
          "& .MuiDialog-paper": {
            width: "400px",
          },
        }}
      >
        <DialogTitle className="seiu-modal-header">{title}</DialogTitle>
        <DialogContent>
          <Typography>{message}</Typography>
          <TextField
            // Focus the name input so the user can start typing immediately
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            required
            label="Template Name"
            value={templateName}
            type="text"
            fullWidth
            variant="standard"
            onChange={handleInputChange}
          />
          {inputIsInvalid && (
            <Box sx={{ color: "red" }}>
              The following characters are invalid for template names:{" "}
              {FORBIDDEN_CHARS.join(" ")}
            </Box>
          )}
          <FormControlLabel
            checked={isCatalistOnly}
            onChange={handleCatalistChange}
            control={<Checkbox />}
            label="Catalist Only"
            disabled={!isNew}
          />
          {isCatalistOnly && isNew && (
            <Box>
              By checking this box, you verify that this template is for
              Catalist matches only and <b>the file will not be sent to VAN</b>.
              This template cannot be converted to general use.
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button className="siteBlueOutlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="siteBlue"
            onClick={handleContinue}
            disabled={inputIsInvalid || templateName === ""}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TemplateNameModal;
